// extracted by mini-css-extract-plugin
module.exports = {"button":"frequency_toggle__button__WO902","button_display_mode_container":"frequency_toggle__button_display_mode_container__zk8eW"};